import React from 'react';
import { Footer, FooterInfo, FooterLink, FooterLinks } from '@rcg/ui-react/lib/components';
import { useGlobal } from '@rcg/ui-react';
import clsx from 'clsx';
import useDictionary from '../../hooks/useDictionary';
import Dictionary from '../../utils/dictionary';
import useStyles from './useStyles';
import { appendGlobalizationToPath } from '../../utils/common';

const AirFooter = ({ className, ...others }) => {
  const classes = useStyles();
  const { data: globalData } = useGlobal();
  const getDictionary = useDictionary(Dictionary);

  const privacyPathUrl = getDictionary(Dictionary.airPrivacyPath.key);
  const privacyHrefUrl = appendGlobalizationToPath(privacyPathUrl, globalData);

  const legalPathUrl = getDictionary(Dictionary.airLegalPath.key);
  const legalHrefUrl = appendGlobalizationToPath(legalPathUrl, globalData);

  return (
    <Footer className={clsx(classes.footer, className)} {...others}>
      <div className={classes.footerContanier}>
        <FooterInfo className={classes.footerInfo}>
          {`© ${new Date().getFullYear()} ${getDictionary(Dictionary.airRcclFooterLabel.key)}`}
        </FooterInfo>
        <FooterLinks>
          <FooterLink href={privacyHrefUrl}>
            {getDictionary(Dictionary.airPrivacyLabel.key)}
          </FooterLink>
          <FooterLink href={legalHrefUrl}>{getDictionary(Dictionary.airLegalLabel.key)}</FooterLink>
        </FooterLinks>
      </div>
    </Footer>
  );
};

export default AirFooter;
